import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Delete = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Delete({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M9.25 16.5C9.25 16.7761 9.47386 17 9.75 17H10.25C10.5261 17 10.75 16.7761 10.75 16.5V11.5C10.75 11.2239 10.5261 11 10.25 11H9.75C9.47386 11 9.25 11.2239 9.25 11.5V16.5Z'
        fill={color}
      />
      <path
        d='M13.25 16.5C13.25 16.7761 13.4739 17 13.75 17H14.25C14.5261 17 14.75 16.7761 14.75 16.5V11.5C14.75 11.2239 14.5261 11 14.25 11H13.75C13.4739 11 13.25 11.2239 13.25 11.5V16.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 6V3.5C8 2.67157 8.67157 2 9.5 2H14.5C15.3284 2 16 2.67157 16 3.5V6H20.5C20.7761 6 21 6.22386 21 6.5V7C21 7.27614 20.7761 7.5 20.5 7.5H19V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V7.5H3.5C3.22386 7.5 3 7.27614 3 7V6.5C3 6.22386 3.22386 6 3.5 6H8ZM14.5 3.5V6H9.5V3.5H14.5ZM6.5 7.5H17.5V20C17.5 20.2761 17.2761 20.5 17 20.5H7C6.72386 20.5 6.5 20.2761 6.5 20V7.5Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'delete-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Delete;
